export class TitleNotification {
  isOriginalTitle = true;
  notificationTitle;

  constructor(notificationTitle, timeIntervalMs = 1000) {
    this.originalTitle = window.document.title;
    this.notificationTitle = notificationTitle;
    this.tabNotificationInterval = setInterval(this._flip, timeIntervalMs);
  }

  _flip = () => {
    if (this.isOriginalTitle) {
      window.document.title = this.notificationTitle;
      this.isOriginalTitle = false;
    } else {
      window.document.title = this.originalTitle;
      this.isOriginalTitle = true;
    }
  };

  clear = () => {
    window.document.title = this.originalTitle;
    clearInterval(this.tabNotificationInterval);
  };
}
export default TitleNotification;
